import { buildGoogleMapsSearchUrl, getAddressDisplayLabel } from '../lib/googleMaps';

/**
 * Dirección clicable que abre Google Maps (escritorio y móvil).
 * Muestra texto legible aunque en BD esté guardada una URL de Maps.
 */
export default function AddressMapLink({ address, className, children }) {
  const displayText = getAddressDisplayLabel(address);
  if (!displayText) return null;

  return (
    <a
      href={buildGoogleMapsSearchUrl(address)}
      target="_blank"
      rel="noopener noreferrer"
      className={className}
    >
      {children ?? displayText}
    </a>
  );
}
